// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__KyfXL","error":"styles_error__7szef","cred":"styles_cred__Gm+84","selection":"styles_selection__VupQz","submit":"styles_submit__OYJcr"};